/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUnreadCountResponse
 */
export interface GetUnreadCountResponse {
    /**
     * Number of unread notifications
     * @type {number}
     * @memberof GetUnreadCountResponse
     */
    count: number;
}

/**
 * Check if a given object implements the GetUnreadCountResponse interface.
 */
export function instanceOfGetUnreadCountResponse(value: object): value is GetUnreadCountResponse {
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function GetUnreadCountResponseFromJSON(json: any): GetUnreadCountResponse {
    return GetUnreadCountResponseFromJSONTyped(json, false);
}

export function GetUnreadCountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUnreadCountResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
    };
}

export function GetUnreadCountResponseToJSON(json: any): GetUnreadCountResponse {
    return GetUnreadCountResponseToJSONTyped(json, false);
}

export function GetUnreadCountResponseToJSONTyped(value?: GetUnreadCountResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
    };
}

